import { Component } from '@angular/core';
import { NavigationService } from 'app/utils/navigation/navigation.service';
import { MetaTagsHelper } from 'app/utils/metaTags/metaTagsHelper';

@Component({
    moduleId: module.id,
    selector: 'terms',
    templateUrl: './terms.component.html',
    styleUrls: ['./terms.component.less', '../../../../../styles/app/covers.less'],
})
export class TermsComponent {
    constructor(public navigationService: NavigationService, private metaTagsHelper: MetaTagsHelper) {
        this.metaTagsHelper.setTitleAndMetaTags('META.TERMS');
    }
}
